import React from "react";
import { Link } from "react-router-dom";

const RegisterSuccessScreen: React.FC = () => {
  return (
    <section className="stats">
      <div className="container">
        <div className="stat-card cta-content center auth-card">
          <h1 className="auth-title">Cadastro realizado!</h1>
          <p className="auth-subtitle">
            Conta criada com sucesso! Importante: Enviamos um e-mail para você
            confirmar seu cadastro.
            <br />
            Verifique sua caixa de entrada — e também a pasta de spam, caso não
            encontre a mensagem.
          </p>

          <div
            className="auth-actions"
            style={{ display: "flex", justifyContent: "center" }}
          >
            <Link to="/login" className="btn-primary">
              Fazer Login
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RegisterSuccessScreen;
